import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Layout, Menu, Icon } from 'antd';
import Auth from "../../auth/Auth";
import routes from "../../const/routes";
const { Sider } = Layout;

function Sidebar({user}){
    let [ collapsed, setCollapsed ] = useState(true);

    function onCollapse(){
        setCollapsed(collapsed = !collapsed);
    }
 
    return(
        <Sider 
            collapsed={collapsed} 
            onCollapse={onCollapse}
            style={{
                overflow: 'auto',
                height: '100vh',
                position: 'fixed',
                left: 0,
            }}
        >
            <div className="logo" />
            <Menu theme="dark" mode="inline">
                <Menu.Item key="0">
                    <Link to={routes.HOME}>
                        <Icon type="home" />
                        <span>Inicio</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to={routes.CLIENTS}>
                        <Icon type="team" />
                        <span>Clientes</span>
                    </Link>
                </Menu.Item>
                {
                    user.profile_info && user.profile_info[0].label !== "User" ?
                        <Menu.Item key="3">
                            <Link to={routes.BRANCHS}>
                                <Icon type="apartment" />
                                <span>Filiais</span>
                            </Link>
                        </Menu.Item>
                    : null
                }
                {
                    user.profile_info && user.profile_info[0].label !== "User" ?
                        <Menu.Item key="4">
                            <Link to={routes.ROOMS}>
                                <Icon type="desktop" />
                                <span>Salas</span>
                            </Link>
                        </Menu.Item>
                    : null
                }
                <Menu.Item key="5">
                    <Link to={routes.VOUCHERS}>
                        <Icon type="qrcode" />
                        <span>Vouchers</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="6" onClick={() => {Auth.logout(() => {return null})}} >
                    <Link to={routes.LOGIN}><Icon type="poweroff" /><span>Sair</span></Link>
                </Menu.Item>
            </Menu>
        </Sider>
    )
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/common/Sidebar.jsx